export default __webpack_public_path__ + "static/media/logo_gladly.81cee83c.svg";